import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import { teal, pink} from '@material-ui/core/colors'

export default createMuiTheme({
	palette: {
		primary: teal,
    	secondary: {
			main: "#6FB7A7"
		}
	},
	shape: {
		borderRadius: 0
	}
})


// WEBPACK FOOTER //
// ./src/styles/times2-theme.js